import { useEffect, useState } from 'react';
import axios from "axios";
import { useAuth } from '../context/AuthContext';
import "./HotelReservationForm.css"

const HotelReservationForm = () => {
    const {businessToken, business} = useAuth()
    const [message, setMessage] = useState('');
    const [hotelReservationInfo, setHotelReservationInfo] = useState([])
    
    // Stavy pro rezervaci
    const [reservationData, setReservationData] = useState({
        business: business._id,
        pricePerNight: "",
        petFee: "",
        cleaningFee: "",
        accountNumber: "",
        checkInTime: "",
        checkOutTime: "",
        numberOfPeople: "",
        deposit: "",
        pet: false,
        description: "",
    });

    // Funkce pro změnu hodnoty v inputech
    const handleChangeData = (e) => {
        const { name, value, type, checked } = e.target;

        setReservationData((prev) => ({
          ...prev,
          [name]: type === "checkbox" ? checked : value,
        }));
      };

    // Odeslání formuláře
    const handleSubmit = async (e) => {
        e.preventDefault();  // Zabraňuje defaultnímu odeslání formuláře
        try {
            // Poslání dat na server
   
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/booking/booking-detail`, 
                {reservationData},
                {
                    headers: {
                        Authorization: `Bearer ${businessToken}`
                    }
                }
            )
            setMessage(response.data.message);  // Nastaví odpověď ze serveru
            setTimeout(() => {
                window.location.reload()
            }, 2000)
        } catch (err) {
            setMessage(err.response?.data?.message);
        }
    };

     //Informace k rezervacim 
 useEffect(() => {
    if (business && businessToken) {
    const fetchHotelInfo = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/booking/list`, 
          {
          params: {businessId: business._id},
          headers: {Authorization: `Bearer ${businessToken}`}
        })
        setHotelReservationInfo(response.data.reservations)
      } catch (err) {
        console.log(err.response?.data?.message)
      }
      }
      fetchHotelInfo()
    }
   }, [business, businessToken])
  
   useEffect(() => {
    if (hotelReservationInfo && hotelReservationInfo.length > 0) {
        setReservationData(prevState => ({
            ...prevState,
            pricePerNight: hotelReservationInfo[0].pricePerNight || "",
            petFee: hotelReservationInfo[0].petFee || "",
            cleaningFee: hotelReservationInfo[0].cleaningFee || "",
            accountNumber: hotelReservationInfo[0].accountNumber || "",
            checkInTime: hotelReservationInfo[0].checkInTime || "",
            checkOutTime: hotelReservationInfo[0].checkOutTime || "",
            numberOfPeople: hotelReservationInfo[0].maxPeople || "",
            deposit: hotelReservationInfo[0].deposit || "",
            pet: hotelReservationInfo[0].pet || false,
            description: hotelReservationInfo[0].description || "",
        }));
    }
}, [hotelReservationInfo]); 
    

    return (
        <div>
            <h2 className='services-title'>Nastavení rezervací pro ubytování</h2>
            
            <form onSubmit={handleSubmit}>
            <div className='settings-container'>
                <h2 className='check-title'>Čas příjezdu:</h2>
                <input
                    className="input-time"
                    type="time"
                    name="checkInTime"
                    value={reservationData.checkInTime}
                    onChange={handleChangeData}
                    required
                    min="00:00"
                    max="23:45"
                    step="900"
                />
                </div>
                <div className='settings-container'>
                    <h2 className='check-title'>Čas odjezdu:</h2>
                <input
                    className="input-time"
                    type="time"
                    name="checkOutTime"
                    value={reservationData.checkOutTime}
                    onChange={handleChangeData}
                    required
                    min="00:00"
                    max="23:45"
                    step="900"
                />
                </div>
                <div className='settings-container'>
                <h2 className='check-title'>Zvířata povolena:</h2>
                <input
                    className="hotel-input-checkbox"
                    type="checkbox"
                    name="pet"
                    checked={reservationData.pet}
                    onChange={handleChangeData}
                />
                </div>
                { reservationData.pet && <div className='settings-container'>
                <h2 className='check-title'>Poplatek za zvíře:</h2>
                 <input
                    className="hotel-input"
                    type="number"
                    name="petFee"
                    value={reservationData.petFee}
                    onChange={handleChangeData}
                />
                </div>
                }
                
                <div className='settings-container'>
                <h2 className='check-title'>Maximální počet osob:</h2>
                <input
                   className="hotel-input"
                    type="number"
                    name="numberOfPeople"
                    value={reservationData.numberOfPeople}
                    onChange={handleChangeData}
                    min="1"
                    required
                />
                </div>
                <div className='settings-container'>
                <h2 className='check-title'>Poplatek za noc:</h2>
                <input
                   className="hotel-input"
                    type="number"
                    name="pricePerNight"
                    value={reservationData.pricePerNight}
                    onChange={handleChangeData}
                    placeholder="Kč"
                    required
                />
                </div>
                <div className='settings-container'>
                <h2 className='check-title'>Poplatek za úklid: </h2>
                <input
                   className="hotel-input"
                    type="number"
                    name="cleaningFee"
                    value={reservationData.cleaningFee}
                    onChange={handleChangeData}
                    placeholder="Kč"
                />
                </div>
                <div className='settings-container'>
                <h2 className='check-title'>Číslo účtu:</h2>
                <input
                   className="hotel-input"
                    type="text"
                    name="accountNumber"
                    value={reservationData.accountNumber}
                    onChange={handleChangeData}
                    required
                />
                </div>
                <div className='settings-container'>
                <h2 className='check-title'>Záloha v procentech:</h2>
                <input 
                   className="hotel-input"
                    type='number'
                    name='deposit'
                    value={reservationData.deposit}
                    onChange={handleChangeData}
                    placeholder='Nepovinné'
                />
                </div>
                <div className='hotel-description-container'>
                <h2 className='check-title'>Poznámka: </h2>
                <textarea
                    className="hotel-input"
                    name="description"
                    value={reservationData.description} 
                    onChange={handleChangeData}
                    placeholder="Zde můžete zadat poznámku k rezervaci, např.: Do kdy se to má zaplatit"
                />
                </div>
                <button className='profile-button' type="submit">Vytvořit informace k rezervaci</button>
            </form>
            {message && <p className='message'>{message}</p>}
            </div> 
        
    );
};

export default HotelReservationForm;